import { MyDetailsComponent } from './my-details.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [MyDetailsComponent],
    imports: [CommonModule, MatAutocompleteModule, SharedModule, RouterModule],
    exports: [MyDetailsComponent],
    providers: []
})
export class MyDetailsModule {}
